import { render, staticRenderFns } from "./StatusDelivery.vue?vue&type=template&id=54a4662e&"
import script from "./StatusDelivery.vue?vue&type=script&lang=js&"
export * from "./StatusDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports